import React from 'react';
import {FieldError} from 'react-hook-form';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';

import {ControllerWrapper} from '@/components/common';
import TextArea from '@/components/help/common/TextArea';
import FormError from '@/components/help/common/FormContainer/FormError';
import {
  useFormContent,
  CONTENT_ERROR_MESSAGE,
} from '@/hooks/help/useFormContent';
import {FORM_FIELDS} from '@/constants/help/form';
import {useFormContainerContext} from '../FormContainerContext';

const Content = () => {
  const {type} = useFormContainerContext();
  const {template, placeholderText, charCount, validateContent, errors} =
    useFormContent({
      type,
    });

  return (
    <div className={styles.section}>
      <div className={styles.textAreaLayout}>
        <ControllerWrapper
          component={TextArea}
          template={template}
          name={FORM_FIELDS.CONTENT}
          rules={{required: CONTENT_ERROR_MESSAGE, validate: validateContent}}
          placeholder={placeholderText}
          error={!!errors.content}
          maxLength={1000}
        />
        <span className={styles.textCount}>
          <em>{charCount}</em>/1,000
        </span>
      </div>

      <FormError
        error={(errors.title as FieldError) || (errors.content as FieldError)}
      />
    </div>
  );
};

export default Content;
